import { Component, EventEmitter, Input, Output } from '@angular/core';

import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

@Component({
  selector: 'see-more-footer',
  templateUrl: './see-more-footer.component.html',
  styleUrls: ['./see-more-footer.component.scss'],
})
export class SeeMoreFooterComponent {
  @Input()
  isLoading: boolean;

  @Output()
  clickSeeMore = new EventEmitter<void>();

  constructor(private fuseTranslationLoaderService: FuseTranslationLoaderService) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }
}

